import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const SocialMediaBranding = () => {
  return (
    <div className="font-['Raleway',sans-serif] bg-white text-gray-900 overflow-x-hidden pt-[90px]">
      
      <Navbar />

      {/* HERO SECTION */}
      <section className="relative min-h-[300px] flex items-center justify-center overflow-hidden">
        {/* Background Image with Overlay */}
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url('https://images.unsplash.com/photo-1611162617474-5b21e879e113?w=1920&q=80')`,
          }}
        />
        {/* Dark Blue Overlay */}
        <div className="absolute inset-0 bg-[#19354a]/90" />
        
        {/* Content */}
        <div className="relative z-10 text-center px-6">
          <motion.h1 
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-8"
          >
            Healthcare Social Media & Branding
          </motion.h1>
          
          {/* Breadcrumb Buttons */}
          <motion.div 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="flex items-center justify-center gap-4 flex-wrap"
          >
            <Link 
              to="/" 
              className="px-8 py-3 bg-[#39a5d3] text-white rounded-full font-semibold hover:bg-[#2a8db8] transition-all"
            >
              Home
            </Link>
            <span className="text-white text-2xl">|</span>
            <Link 
              to="/services" 
              className="px-8 py-3 bg-[#39a5d3] text-white rounded-full font-semibold hover:bg-[#2a8db8] transition-all"
            >
              Services
            </Link>
            <span className="text-white text-2xl">|</span>
            <span className="px-8 py-3 bg-[#39a5d3] text-white rounded-full font-semibold">
              Social Media & Branding
            </span>
          </motion.div>
        </div>
      </section>

      {/* CONTENT SECTION */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            
            {/* Left - Image & Tagline */}
            <motion.div
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
            >
              {/* Tag */}
              <span className="inline-block px-4 py-2 border border-gray-300 rounded-md text-gray-600 text-sm mb-6">
                HEALTHCARE SOCIAL MEDIA
              </span>
              
              {/* Tagline */}
              <h2 className="text-2xl lg:text-3xl font-bold text-gray-900 mb-8">
                The Leading <span className="text-[#19354a]">Healthcare Social Media & BrandingPartner</span> To Build Your Doctor Brand!
              </h2>
              
              <img 
                src="/images/meta14.png" 
                alt="Healthcare Social Media & Branding"
                className="w-full max-w-[450px] h-auto mx-auto"
              />
            </motion.div>

            {/* Right - Content */}
            <div>
              <motion.p 
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5 }}
                className="text-gray-700 leading-relaxed mb-6"
              >
                In today's digital healthcare landscape, 77% of patients search for doctors online before booking appointments. Social media is no longer optional—it's essential for building patient trust and growing your medical practice. Your healthcare social media presence is often the first impression potential patients have of your practice.
              </motion.p>
              
              <motion.p 
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.1 }}
                className="text-gray-700 leading-relaxed mb-6"
              >
                At Docmize, we're passionate about <strong className="text-[#19354a]">building doctor brands through strategic social media</strong>. From HIPAA-compliant content management to patient education posts and doctor thought leadership, our healthcare social media team creates authentic content that builds trust, educates patients, and drives appointments.
              </motion.p>

              <motion.p 
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.2 }}
                className="text-gray-700 leading-relaxed mb-6"
              >
                Whether you're looking to build your personal doctor brand, increase patient engagement, or establish your medical practice as a trusted healthcare authority, our social media specialists deliver results. We handle Instagram, Facebook, LinkedIn management and all patient interactions professionally.
              </motion.p>

              <motion.p 
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.3 }}
                className="text-gray-900 font-semibold leading-relaxed mb-8"
              >
                Build patient trust online. Partner with Docmize and let's grow your medical practice together!
              </motion.p>

              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.4 }}
              >
                <Link 
                  to="/contact" 
                  className="inline-block px-8 py-4 bg-[#19354a] text-white rounded-lg font-semibold hover:bg-[#0f2133] transition-all"
                >
                  GET A QUOTE
                </Link>
              </motion.div>
            </div>

          </div>
        </div>
      </section>

      

{/* WHY CHOOSE US - BLUE SECTION */}
<section className="relative py-20 overflow-hidden">
  {/* Dark Blue Background */}
  <div 
    className="absolute inset-0"
    style={{
      background: 'linear-gradient(135deg, #0f1c3f 0%, #1a2d5e 50%, #152349 100%)'
    }}
  />
  
  {/* Diagonal Lines Pattern */}
  <div className="absolute inset-0 overflow-hidden">
    {/* Main diagonal lines */}
    <div 
      className="absolute inset-0"
      style={{
        backgroundImage: `repeating-linear-gradient(
          45deg,
          transparent,
          transparent 50px,
          rgba(59, 130, 246, 0.1) 50px,
          rgba(59, 130, 246, 0.1) 52px
        )`
      }}
    />
    {/* Additional accent lines */}
    <div className="absolute top-0 left-[20%] w-[2px] h-full bg-gradient-to-b from-transparent via-blue-500/20 to-transparent transform rotate-[30deg] origin-top"></div>
    <div className="absolute top-0 left-[40%] w-[2px] h-full bg-gradient-to-b from-transparent via-blue-400/30 to-transparent transform rotate-[30deg] origin-top"></div>
    <div className="absolute top-0 left-[60%] w-[3px] h-full bg-gradient-to-b from-transparent via-blue-500/20 to-transparent transform rotate-[30deg] origin-top"></div>
    <div className="absolute top-0 left-[80%] w-[2px] h-full bg-gradient-to-b from-transparent via-blue-400/15 to-transparent transform rotate-[30deg] origin-top"></div>
  </div>

  {/* Content */}
  <div className="relative z-10 max-w-7xl mx-auto px-6">
    
    {/* Section Header */}
    <motion.div 
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6 }}
      className="text-center mb-12"
    >
      <h2 className="text-3xl lg:text-4xl xl:text-5xl font-bold text-white mb-4">
        Why Choose Our Healthcare Social Media Services?
      </h2>
      <p className="text-white/70 text-lg">
        Here's why doctors and hospitals trust us with their social media:
      </p>
    </motion.div>

    {/* Benefits Grid - 2 Columns */}
    <div className="grid md:grid-cols-2 gap-x-16 gap-y-8 max-w-5xl mx-auto">
      
      {/* Left Column */}
      <div className="space-y-8">
        <motion.div 
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.1 }}
          className="flex items-start gap-4"
        >
          <span className="text-[#39a5d3] text-2xl font-bold">»</span>
          <p className="text-white text-lg">HIPAA-compliant social media management for doctors and hospitals</p>
        </motion.div>

        <motion.div 
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.2 }}
          className="flex items-start gap-4"
        >
          <span className="text-[#39a5d3] text-2xl font-bold">»</span>
          <p className="text-white text-lg">Patient education content that builds trust and medical authority</p>
        </motion.div>

        <motion.div 
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.3 }}
          className="flex items-start gap-4"
        >
          <span className="text-[#39a5d3] text-2xl font-bold">»</span>
          <p className="text-white text-lg">Strategic content planning for Instagram, Facebook & LinkedIn</p>
        </motion.div>

        <motion.div 
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.4 }}
          className="flex items-start gap-4"
        >
          <span className="text-[#39a5d3] text-2xl font-bold">»</span>
          <p className="text-white text-lg">Professional comment and DM management for patient inquiries</p>
        </motion.div>
      </div>

      {/* Right Column */}
      <div className="space-y-8">
        <motion.div 
          initial={{ opacity: 0, x: 30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.1 }}
          className="flex items-start gap-4"
        >
          <span className="text-[#39a5d3] text-2xl font-bold">»</span>
          <p className="text-white text-lg">Healthcare influencer outreach and medical community collaborations</p>
        </motion.div>

        <motion.div 
          initial={{ opacity: 0, x: 30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.2 }}
          className="flex items-start gap-4"
        >
          <span className="text-[#39a5d3] text-2xl font-bold">»</span>
          <p className="text-white text-lg">Doctor brand building and thought leadership positioning</p>
        </motion.div>

        <motion.div 
          initial={{ opacity: 0, x: 30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.3 }}
          className="flex items-start gap-4"
        >
          <span className="text-[#39a5d3] text-2xl font-bold">»</span>
          <p className="text-white text-lg">Health awareness campaigns that drive patient engagement</p>
        </motion.div>

        <motion.div 
          initial={{ opacity: 0, x: 30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.4 }}
          className="flex items-start gap-4"
        >
          <span className="text-[#39a5d3] text-2xl font-bold">»</span>
          <p className="text-white text-lg">Monthly performance reports with patient engagement metrics</p>
        </motion.div>
      </div>

    </div>
  </div>
</section>

      {/* OUR SERVICES SECTION */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          
          {/* Section Header */}
          <motion.div 
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="text-center mb-12"
          >
            <h2 className="text-3xl lg:text-4xl xl:text-5xl font-bold text-[#19354a] mb-4">
              Our Healthcare Social Media Services
            </h2>
            <p className="text-gray-600 max-w-3xl mx-auto">
              Comprehensive social media solutions for doctors, hospitals, and medical practices
            </p>
          </motion.div>

          {/* Services Grid */}
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            
            {/* Service 1 */}
            <motion.div
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.1 }}
              whileHover={{ y: -10 }}
              className="bg-white rounded-2xl p-6 border-2 border-[#19354a] hover:shadow-xl transition-all duration-300"
            >
              <div className="w-14 h-14 bg-[#19354a] rounded-xl flex items-center justify-center mb-4">
                <svg className="w-7 h-7 text-white" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M17 8h2a2 2 0 012 2v6a2 2 0 01-2 2h-2v4l-4-4H9a1.994 1.994 0 01-1.414-.586m0 0L11 14h4a2 2 0 002-2V6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2v4l.586-.586z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-[#19354a] mb-3">Social Media Management</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                Complete HIPAA-compliant social media management across all platforms.
              </p>
            </motion.div>

            {/* Service 2 */}
            <motion.div
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.2 }}
              whileHover={{ y: -10 }}
              className="bg-white rounded-2xl p-6 border-2 border-[#19354a] hover:shadow-xl transition-all duration-300"
            >
              <div className="w-14 h-14 bg-[#19354a] rounded-xl flex items-center justify-center mb-4">
                <svg className="w-7 h-7 text-white" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-[#19354a] mb-3">Content Planning & Posting</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                Strategic content calendars with consistent patient education posting.
              </p>
            </motion.div>

            {/* Service 3 */}
            <motion.div
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.3 }}
              whileHover={{ y: -10 }}
              className="bg-white rounded-2xl p-6 border-2 border-[#19354a] hover:shadow-xl transition-all duration-300"
            >
              <div className="w-14 h-14 bg-[#19354a] rounded-xl flex items-center justify-center mb-4">
                <svg className="w-7 h-7 text-white" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M3 5h12M9 3v2m1.048 9.5A18.022 18.022 0 016.412 9m6.088 9h7M11 21l5-10 5 10M12.751 5C11.783 10.77 8.07 15.61 3 18.129" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-[#19354a] mb-3">Instagram, Facebook & LinkedIn</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                Platform-specific strategies for medical practice growth.
              </p>
            </motion.div>

            {/* Service 4 */}
            <motion.div
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.4 }}
              whileHover={{ y: -10 }}
              className="bg-white rounded-2xl p-6 border-2 border-[#19354a] hover:shadow-xl transition-all duration-300"
            >
              <div className="w-14 h-14 bg-[#19354a] rounded-xl flex items-center justify-center mb-4">
                <svg className="w-7 h-7 text-white" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-[#19354a] mb-3">Comment & DM Management</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                Professional patient inquiry handling and engagement.
              </p>
            </motion.div>

            {/* Service 5 */}
            <motion.div
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.5 }}
              whileHover={{ y: -10 }}
              className="bg-white rounded-2xl p-6 border-2 border-[#19354a] hover:shadow-xl transition-all duration-300"
            >
              <div className="w-14 h-14 bg-[#19354a] rounded-xl flex items-center justify-center mb-4">
                <svg className="w-7 h-7 text-white" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-[#19354a] mb-3">Influencer & Medical Outreach</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                Healthcare influencer partnerships and collaborations.
              </p>
            </motion.div>

            {/* Service 6 */}
            <motion.div
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.6 }}
              whileHover={{ y: -10 }}
              className="bg-white rounded-2xl p-6 border-2 border-[#19354a] hover:shadow-xl transition-all duration-300"
            >
              <div className="w-14 h-14 bg-[#19354a] rounded-xl flex items-center justify-center mb-4">
                <svg className="w-7 h-7 text-white" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-[#19354a] mb-3">Doctor Brand Building</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                Personal branding for doctors to establish thought leadership.
              </p>
            </motion.div>

          </div>
        </div>
      </section>

     {/* ENTRUST US SECTION */}
<section className="py-16 bg-white">
  <div className="max-w-7xl mx-auto px-6">
    <div className="grid lg:grid-cols-2 gap-12 items-center">
      
      {/* Left - Content */}
      <motion.div
        initial={{ opacity: 0, x: -50 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
      >
        <h2 className="text-3xl lg:text-4xl xl:text-5xl font-bold text-[#19354a] mb-2">
          Entrust us to Build
        </h2>
        <h2 className="text-3xl lg:text-4xl xl:text-5xl font-bold text-[#19354a] mb-4">
          Your Doctor Brand,
        </h2>
        <h3 className="text-2xl lg:text-3xl font-bold text-[#19354a] mb-2">
          Engage Patients Authentically
        </h3>
        <h3 className="text-2xl lg:text-3xl font-bold text-[#19354a] mb-8">
          and Grow Your Medical Practice.
        </h3>

        {/* Checklist Items */}
        <div className="space-y-5">
          <motion.div 
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.4, delay: 0.1 }}
            className="flex items-start gap-4"
          >
            <div className="w-6 h-6 bg-[#E85A2C] rounded-full flex items-center justify-center flex-shrink-0 mt-1">
              <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" strokeWidth={3} viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
              </svg>
            </div>
            <p className="text-gray-700 leading-relaxed">
              Create a trusted doctor brand with strategic content that showcases your medical expertise and builds patient confidence.
            </p>
          </motion.div>

          <motion.div 
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.4, delay: 0.2 }}
            className="flex items-start gap-4"
          >
            <div className="w-6 h-6 bg-[#E85A2C] rounded-full flex items-center justify-center flex-shrink-0 mt-1">
              <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" strokeWidth={3} viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
              </svg>
            </div>
            <p className="text-gray-700 leading-relaxed">
              Produce engaging patient education content that positions your practice as a healthcare authority in your community.
            </p>
          </motion.div>

          <motion.div 
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.4, delay: 0.3 }}
            className="flex items-start gap-4"
          >
            <div className="w-6 h-6 bg-[#E85A2C] rounded-full flex items-center justify-center flex-shrink-0 mt-1">
              <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" strokeWidth={3} viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
              </svg>
            </div>
            <p className="text-gray-700 leading-relaxed">
              Manage patient interactions professionally across all social platforms while maintaining HIPAA compliance.
            </p>
          </motion.div>

          <motion.div 
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.4, delay: 0.4 }}
            className="flex items-start gap-4"
          >
            <div className="w-6 h-6 bg-[#E85A2C] rounded-full flex items-center justify-center flex-shrink-0 mt-1">
              <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" strokeWidth={3} viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
              </svg>
            </div>
            <p className="text-gray-700 leading-relaxed">
              Build a consistent social media presence that drives appointment bookings and patient referrals to your practice.
            </p>
          </motion.div>
        </div>
      </motion.div>

      {/* Right - Image */}
      <motion.div
        initial={{ opacity: 0, x: 50 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6, delay: 0.2 }}
        className="flex justify-center"
      >
        <img 
          src="/images/creative.png" 
          alt="Build Your Doctor Brand"
          className="w-full max-w-[500px] h-auto"
        />
      </motion.div>

    </div>
  </div>
</section>

      {/* BENEFITS SECTION */}
<section className="py-16 bg-white">
  <div className="max-w-7xl mx-auto px-6">
    
    {/* Section Header */}
    <motion.div 
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6 }}
      className="text-center mb-16"
    >
      <h2 className="text-3xl lg:text-4xl xl:text-5xl font-bold text-[#19354a] mb-4">
        Reap the Benefits of Healthcare Social Media
      </h2>
      <h3 className="text-2xl lg:text-3xl font-bold text-[#19354a] mb-6">
        AT <span className="text-[#19354a]">DOCMIZE</span>
      </h3>
      <p className="text-gray-600 max-w-4xl mx-auto leading-relaxed">
        Our strategic social media process builds patient trust, establishes your medical expertise, and drives consistent practice growth through authentic engagement.
      </p>
    </motion.div>

    {/* Benefit 1 - Image Right */}
    <div className="grid lg:grid-cols-2 gap-0 mb-8">
      <motion.div 
        initial={{ opacity: 0, x: -50 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        className="bg-[#fff4e6] p-6 lg:p-10 flex items-center border-l-4 border-[#19354a]"
      >
        <div>
          <h3 className="text-2xl lg:text-3xl font-bold text-[#19354a] mb-4">
            Strategic Content Planning
          </h3>
          <p className="text-gray-700 leading-relaxed">
            We create comprehensive healthcare content calendars tailored to your medical specialty. Every post educates patients about health topics, showcases your expertise, and builds trust while maintaining HIPAA compliance and professional medical standards.
          </p>
        </div>
      </motion.div>
      <motion.div 
        initial={{ opacity: 0, x: 50 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6, delay: 0.2 }}
        className="bg-[#e8f4fc]"
      >
        <img 
          src="/images/meta10.png" 
          alt="Content Planning"
          className="w-full h-full min-h-[280px] object-cover"
        />
      </motion.div>
    </div>

    {/* Benefit 2 - Image Left */}
    <div className="grid lg:grid-cols-2 gap-0 mb-8">
      <motion.div 
        initial={{ opacity: 0, x: -50 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        className="bg-[#e6f7f0] order-2 lg:order-1"
      >
        <img 
          src="/images/creative2.png" 
          alt="Patient Engagement"
          className="w-full h-full min-h-[280px] object-cover"
        />
      </motion.div>
      <motion.div 
        initial={{ opacity: 0, x: 50 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6, delay: 0.2 }}
        className="bg-[#e6f2e6] p-6 lg:p-10 flex items-center order-1 lg:order-2 border-r-4 border-[#E85A2C]"
      >
        <div>
          <h3 className="text-2xl lg:text-3xl font-bold text-[#E85A2C] mb-4">
            Patient Engagement & Community
          </h3>
          <p className="text-gray-700 leading-relaxed">
            Our team professionally manages all patient comments, direct messages, and inquiries. We respond promptly to questions, foster meaningful engagement, and build an active patient community that trusts your medical practice and recommends your services.
          </p>
        </div>
      </motion.div>
    </div>

    {/* Benefit 3 - Image Right */}
    <div className="grid lg:grid-cols-2 gap-0 mb-8">
      <motion.div 
        initial={{ opacity: 0, x: -50 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        className="bg-[#f0e6f7] p-6 lg:p-10 flex items-center border-l-4 border-[#19354a]"
      >
        <div>
          <h3 className="text-2xl lg:text-3xl font-bold text-[#19354a] mb-4">
            Doctor Brand Building
          </h3>
          <p className="text-gray-700 leading-relaxed">
            We position you as a healthcare thought leader through strategic personal branding. From highlighting your medical expertise to sharing patient success stories, we build a trusted doctor brand that attracts quality patients and establishes you as an authority in your specialty.
          </p>
        </div>
      </motion.div>
      <motion.div 
        initial={{ opacity: 0, x: 50 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6, delay: 0.2 }}
        className="bg-[#e6e9f7]"
      >
        <img 
          src="/images/creative3.png" 
          alt="Doctor Branding"
          className="w-full h-full min-h-[280px] object-cover"
        />
      </motion.div>
    </div>

    {/* Benefit 4 - Image Left */}
    <div className="grid lg:grid-cols-2 gap-0">
      <motion.div 
        initial={{ opacity: 0, x: -50 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        className="bg-[#fce8e8] order-2 lg:order-1"
      >
        <img 
          src="/images/meta6.png" 
          alt="Performance Analytics"
          className="w-full h-full min-h-[280px] object-cover"
        />
      </motion.div>
      <motion.div 
        initial={{ opacity: 0, x: 50 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6, delay: 0.2 }}
        className="bg-[#fff0e6] p-6 lg:p-10 flex items-center order-1 lg:order-2 border-r-4 border-[#E85A2C]"
      >
        <div>
          <h3 className="text-2xl lg:text-3xl font-bold text-[#E85A2C] mb-4">
            Performance Analytics & Growth
          </h3>
          <p className="text-gray-700 leading-relaxed">
            We continuously monitor your social media performance with detailed analytics on patient engagement, reach, and appointment inquiries. Our team provides monthly reports showing what's working and optimizes your strategy to maximize patient acquisition and practice growth.
          </p>
        </div>
      </motion.div>
    </div>

  </div>
</section>


{/* FAQ SECTION */}
<section className="py-16 bg-white">
  <div className="max-w-7xl mx-auto px-6">
    
    {/* Section Header */}
    <motion.div 
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6 }}
      className="text-center mb-12"
    >
      <h2 className="text-3xl lg:text-4xl font-bold text-[#19354a]">
        Frequently Asked Questions about
      </h2>
      <h3 className="text-3xl lg:text-4xl font-bold text-[#19354a]">
        Healthcare Social Media Services.
      </h3>
    </motion.div>

    {/* FAQ Content - Image Left, Questions Right */}
    <div className="grid lg:grid-cols-2 gap-12 items-start">
      
      {/* Left - Image */}
      <motion.div
        initial={{ opacity: 0, x: -50 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        className="flex justify-center lg:sticky lg:top-24"
      >
        <img 
          src="/images/faq-img.png" 
          alt="FAQ Healthcare Social Media"
          className="w-full max-w-[220px] h-auto"
        />
      </motion.div>

      {/* Right - FAQ Items */}
      <div className="space-y-4">
        {[
          {
            question: "Is healthcare social media marketing HIPAA-compliant?",
            answer: "Yes! All our social media content is created with HIPAA compliance in mind. We never share patient information, avoid identifiable health details, and follow strict healthcare privacy regulations. Our team is trained in medical marketing ethics to protect patient confidentiality."
          },
          {
            question: "What platforms should my medical practice focus on?",
            answer: "We recommend Instagram and Facebook for most medical practices to reach patients where they spend time. LinkedIn is ideal for hospitals and specialists targeting professional referrals. We analyze your target patient demographics and specialty to create the best platform strategy."
          },
          {
            question: "How often should we post on social media?",
            answer: "We recommend 3-5 posts per week on Instagram and Facebook for consistent patient engagement, and 2-3 posts weekly on LinkedIn. The key is maintaining quality over quantity—every post should provide value through patient education, health tips, or practice updates."
          },
          {
            question: "Can you help build my personal brand as a doctor?",
            answer: "Absolutely! We specialize in doctor brand building through strategic content highlighting your medical expertise, patient testimonials, and healthcare insights. We position you as a thought leader in your specialty, helping you attract quality patients and build trust in your community."
          },
          {
            question: "How do you handle patient questions on social media?",
            answer: "Our team professionally manages all comments and DMs with HIPAA compliance. We respond promptly to general health inquiries, direct appointment requests appropriately, and never discuss specific medical conditions publicly. All patient interactions build trust while maintaining professional boundaries."
          }
        ].map((faq, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.4, delay: index * 0.1 }}
          >
            <details className="group">
              <summary className="flex items-center justify-between p-5 bg-[#19354a] rounded-lg cursor-pointer list-none">
                <span className="font-semibold text-white">{faq.question}</span>
                <span className="text-white text-2xl font-light group-open:hidden">+</span>
                <span className="text-white text-2xl font-light hidden group-open:block">−</span>
              </summary>
              <div className="px-5 py-4 bg-gray-50 rounded-b-lg text-gray-700 leading-relaxed -mt-2">
                {faq.answer}
              </div>
            </details>
          </motion.div>
        ))}
      </div>

    </div>
  </div>
</section>

      {/* CTA SECTION */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <motion.h2 
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="text-3xl lg:text-4xl font-bold text-[#19354a] mb-6"
          >
            Ready to Build Your Doctor Brand on Social Media?
          </motion.h2>
          <motion.p 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="text-gray-600 text-lg mb-8"
          >
            Let our healthcare social media experts create a trusted online presence that educates patients and drives appointments to your medical practice.
          </motion.p>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="flex flex-col sm:flex-row gap-4 justify-center"
          >
            <Link 
              to="/contact" 
              className="px-8 py-4 bg-[#19354a] text-white rounded-lg font-semibold hover:bg-[#0f2133] transition-all"
            >
              Get a Free Consultation
            </Link>
            <a 
              href="tel:+918920845297" 
              className="px-8 py-4 border-2 border-[#19354a] text-[#19354a] rounded-lg font-semibold hover:bg-[#19354a] hover:text-white transition-all"
            >
              Call Us Now
            </a>
          </motion.div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default SocialMediaBranding;